import React from 'react';
import { DataGrid, esES } from '@mui/x-data-grid';
import { Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setDashboardNodeSelected } from '../../../store/fuse/dashboard';
import { setProgressBarColor } from '../utils';



const rows = [
  {
    id: 1,
    dsnodo: 'Nodo 1',
    dslectura: '29',
  },
  {
    id: 2,
    dsnodo: 'Nodo 2',
    dslectura: '47',
  },
  {
    id: 3,
    dsnodo: 'Nodo 3',
    dslectura: '90',
  },
  {
    id: 4,
    dsnodo: 'Nodo 4',
    dslectura: '10',
  },
  {
    id: 5,
    dsnodo: 'Nodo 5',
    dslectura: '76',
  },
  {
    id: 6,
    dsnodo: 'Nodo 6',
    dslectura: '79',
  },
  {
    id: 7,
    dsnodo: 'Nodo 7',
    dslectura: '91',
  },
];

const HighPacketLossNodes = () => {
  const data = useSelector((state) => state?.fuse?.dashboard?.dashboard?.irregularNodes.highLossPackage);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);
  const currentMetricThresholds = useSelector((state) => state?.fuse?.dashboard?.metricThresholds);

  const columns = [
    {
      field: 'dsnodo',
      headerName: 'Nodo',
      flex: 1,
    },
    {
      field: 'paquetesPerdidos',
      headerName: 'Pérdida Porcentaje',
      description: 'Valores RX',
      sortable: false,
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const [progressBarColor, progressBarLabelColor] = setProgressBarColor(
          params.row?.paquetesPerdidos,
          'paquetes',
          currentMetricThresholds
        );
        return (
          <Typography variant="body2" color={progressBarLabelColor}>{`${Number(params.row?.paquetesPerdidos).toFixed(2)}%`}</Typography>
        );
      },
    },
  ];

  const handleRowClick = (row) => {
    dispatch(setDashboardNodeSelected('/dashboard', row.row.dsnodo));
    navigate(`/dashboard/${row.row.nodeId}`);
  };

  return (
    <div
      className="flex max-w-full gap-0 m-10 rounded-lg flex-col flex-grow"
      style={{ height: '565px', backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}
    >
      <strong className="title-chart" style={{ marginTop: '10px', marginBottom: '10px' }}>
        Nodos con Alta Pérdida de Paquetes
      </strong>
      <DataGrid
        localeText={{
          ...esES.components.MuiDataGrid.defaultProps.localeText,
          noRowsLabel: 'No hay nodos', // You can customize this string
        }}
        initialState={{
          sorting: {
            sortModel: [{ field: 'dslectura', sort: 'desc' }],
          },
        }}
        headerHeight={0}
        rows={data}
        columns={columns}
        disableRowSelectionOnClick
        hideFooter
        onRowClick={handleRowClick}
      />
    </div>
  );
};

export default HighPacketLossNodes;
